"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.string.starts-with");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _router2 = _interopRequireDefault(require("@/router"));
// progress bar
// progress bar style
// get token from cookie

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration
//无需登入就可以查看的页面
var whiteList = ['/containerTypeDetail', '/bookingJapanDgList', '/topMenu/searchFile', '/helpDocuments', '/portContacts', '/register', '/topMenu/tariffs', '/basicInfo/contact', '/topMenu/carbonCalculator', '/topMenu/surchargeAndMiscellaneous', '/topMenu/cargoTrack', '/topMenu/vesselMovementSearch', '/topMenu/voyagePlanSearch', '/home', '/topMenu/equipmentFee', '/WechatProfile', '/WechatDisclaimer', '/questionnaire']; // no redirect whitelist
//登入后可以查看的页面，无需权限
var authWhiteList = ['/userCenter/billConsigneeApplication', '/userCenter/userCenter', '/topMenu/vesselInfo', '/topMenu/vgmApply', '/topMenu/release', '/topMenu/dangerCargoSpecContainer', '/topMenu/cargoInfoSearch', '/topMenu/delivery', '/topMenu/containerInfo', '/topMenu/demurrageCalculation', '/bookingSpace/ediFeedBack/sendFailureGuidebook', '/topMenu/issueApply']; // no redirect whitelist
var whiteList2 = ['/auth-redirect', '/404', '/401']; // no redirect whitelist
_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var path, hasToken, hasLogin, res, accessRoutes, _res, message;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          path = to.path; // start progress bar
          _nprogress.default.start();

          // set page title
          document.title = (0, _getPageTitle.default)(to.meta);

          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)();
          console.log('hasToken===', hasToken);
          if (!hasToken) {
            _context.next = 39;
            break;
          }
          // 单独处理
          // if (whiteList2.indexOf(to.path) !== -1) {
          //   NProgress.done()
          //   next()
          //   return
          // }
          // 判断用户有没有用户信息
          hasLogin = Object.keys(_store.default.getters.userInfo).length;
          console.log('hasLogin===是否有用户信息2222', hasLogin);
          if (!hasLogin) {
            _context.next = 15;
            break;
          }
          _context.next = 11;
          return alertFun2(path);
        case 11:
          res = _context.sent;
          res && next();
          _context.next = 37;
          break;
        case 15:
          _context.prev = 15;
          _context.next = 18;
          return _store.default.dispatch('user/getInfo');
        case 18:
          _context.next = 20;
          return _store.default.dispatch('user/getBtnPermissions');
        case 20:
          _context.next = 22;
          return _store.default.dispatch('permission/generateRoutes');
        case 22:
          accessRoutes = _context.sent;
          // await store.dispatch('app/getStatusColor')
          // await store.dispatch('app/getInputChineseCompanyConfig')
          // dynamically add accessible routes
          _router.default.addRoutes(accessRoutes);
          // console.log('accessRoutes===9999',router)
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          _context.next = 26;
          return alertFun2(path);
        case 26:
          _res = _context.sent;
          _res && next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
            replace: true
          }));
          // next({ ...to, replace: true })
          _context.next = 37;
          break;
        case 30:
          _context.prev = 30;
          _context.t0 = _context["catch"](15);
          _context.next = 34;
          return _store.default.dispatch('user/resetToken');
        case 34:
          _elementUi.Message.error(_context.t0 || 'Has Error');
          next('/home');
          _nprogress.default.done();
        case 37:
          _context.next = 40;
          break;
        case 39:
          if (path.startsWith('/redirect') || to.path.startsWith('/cancelVesselPlan') || to.path.startsWith('/cancelCargo') || whiteList.indexOf(to.path) !== -1) {
            console.log('to.path 1111', to.path);
            // in the free login whitelist, go directly
            next();
          } else {
            message = _store.default.state.app.language === 'zh' ? '请先登录,再进行操作' : 'Please login first and then operate';
            _elementUi.Message.warning(message);

            // Message({
            //   message: this.$t('home.noLoginMessage') ,
            //   type: 'warning'
            // })
            // other pages that do not have permission to access are redirected to the login page.
            next('/');
            _nprogress.default.done();
          }
          // 当用户只是
          // const accessRoutes = await store.dispatch('permission/generateRoutes')
          // router.addRoutes(accessRoutes)
        case 40:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[15, 30]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});
var alertFun = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(next) {
    var languageFlag;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          languageFlag = _store.default.state.app.language === 'zh';
          _context3.next = 3;
          return _elementUi.MessageBox.alert(languageFlag ? '当前登录已过期，请重新登录。' : 'The current login has expired. Please log in again.', languageFlag ? '提示' : 'Hint', {
            distinguishCancelAndClose: true,
            confirmButtonText: languageFlag ? '确定' : 'Confirm'
          }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
            return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _store.default.dispatch('user/logout');
                case 2:
                  next('/login');
                  _nprogress.default.done();
                  return _context2.abrupt("return");
                case 5:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }))).catch(function () {});
        case 3:
          _context3.t0 = _context3.sent;
          if (!(_context3.t0 !== 'confirm')) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return");
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function alertFun(_x4) {
    return _ref2.apply(this, arguments);
  };
}();
var alertFun2 = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(path) {
    var res;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          res = false;
          if (!(path.startsWith('/redirect') || path.startsWith('/cancelVesselPlan') || path.startsWith('/cancelCargo') || whiteList.indexOf(path) !== -1 || authWhiteList.indexOf(path) !== -1)) {
            _context4.next = 5;
            break;
          }
          res = true;
          _context4.next = 8;
          break;
        case 5:
          _context4.next = 7;
          return _store.default.dispatch('user/checkPageAccessPermission', path);
        case 7:
          res = _context4.sent;
        case 8:
          return _context4.abrupt("return", res);
        case 9:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function alertFun2(_x5) {
    return _ref4.apply(this, arguments);
  };
}();